// extracted by mini-css-extract-plugin
export default {"collaborator-select":"hCDt","collaboratorSelect":"hCDt"};